import { render, staticRenderFns } from "./UserPolicy.vue?vue&type=template&id=ec1ed8b6&scoped=true&"
import script from "./UserPolicy.vue?vue&type=script&lang=js&"
export * from "./UserPolicy.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/zx-agreement.css?vue&type=style&index=0&id=ec1ed8b6&prod&scoped=true&lang=css&"
import style1 from "./UserPolicy.vue?vue&type=style&index=1&id=ec1ed8b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1ed8b6",
  null
  
)

export default component.exports